import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
const badgeVariants = cva('inline-flex items-center gap-1 rounded-[var(--radius-2)] font-medium', {
    variants: {
        variant: {
            neutral: 'bg-[var(--color-surface-sunken)] text-[var(--color-text-secondary)] border border-[var(--color-border-subtle)]',
            accent: 'bg-[var(--color-brand-bg)] text-[var(--color-brand-fg)]',
            success: 'bg-[var(--color-state-success-bg)] text-[var(--color-state-success-fg)]',
            warning: 'bg-[var(--color-state-warning-bg)] text-[var(--color-state-warning-fg)]',
            danger: 'bg-[var(--color-state-danger-bg)] text-[var(--color-state-danger-fg)]',
            info: 'bg-[var(--color-state-info-bg)] text-[var(--color-state-info-fg)]',
            /**
             * Обведён, а не залит — для сущности, которая стоит в одной строке с
             * `neutral` и обязана читаться как ДРУГАЯ: ручной тег рядом с темой
             * классификатора (`ui-domain/TagChip`).
             */
            outline: 'bg-transparent text-[var(--color-text-secondary)] border border-[var(--color-border-default)]',
        },
        size: {
            sm: 'px-1.5 py-0.5 text-xs',
            md: 'px-2 py-0.5 text-sm',
        },
    },
    defaultVariants: { variant: 'neutral', size: 'sm' },
});
export const Badge = React.forwardRef(({ className, variant, size, ...props }, ref) => (_jsx("span", { ref: ref, className: cn(badgeVariants({ variant, size }), className), ...props })));
Badge.displayName = 'Badge';
//# sourceMappingURL=badge.js.map